<template>
  <v-card
    class="screen-height-container flex-content"
  >
    <v-card-title>
      <h2>Help</h2>
      <v-spacer />
      <r-button
        :outlined="true"
        @onclick="onNewTab"
        icon="open_in_browser"
        color="primary"
        class="mr-1"
        label="Open in New Tab"
      />

      <r-button
        :outlined="true"
        @onclick="onClose"
        icon="close"
        color="primary"
        label="Close"
      />
    </v-card-title>
    <v-card-text>
      <iframe
        v-if="src"
        frameborder="0"
        :src="src"
        style="width: 100%; height: 100%"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "HelpTopicViewer",
  data() {
    return {
      src: null,
      baseUrl: "https://help.agrifyinsights.com/index.htm#t=",
    };
  },
  computed: {
    ...mapGetters([
      "isViewingHelp",
      "tempHelpTopicKey",
      "componentHelpTopicKey",
      "routeHelpTopicKey",
      "defaultHelpTopicKey",
      "helpTopicByKey",
    ]),
  },
  watch: {
    isViewingHelp(newValue) {
      if (newValue) {
        this.buildSrc();
      } else {
        this.src = null;
      }
    },
  },
  mounted() {
    this.buildSrc();
  },
  methods: {
    ...mapActions(["setIsViewingHelp", "setTempHelpTopicKey"]),
    buildSrc() {
      let topicKey = this.defaultHelpTopicKey;
      if (this.tempHelpTopicKey) {
        topicKey = this.tempHelpTopicKey;
        this.setTempHelpTopicKey(null);
      } else if (this.componentHelpTopicKey) {
        topicKey = this.componentHelpTopicKey;
      } else if (this.routeHelpTopicKey) {
        topicKey = this.routeHelpTopicKey;
      }
      let helpTopic = this.helpTopicByKey(topicKey);
      if (!helpTopic) {
        return;
      }
      // remove unescape if using framed help theme
      this.src = this.baseUrl + unescape(helpTopic.topicUrl);
    },
    onClose() {
      this.setIsViewingHelp(false);
    },
    onNewTab() {
      window.open(this.src);
    },
  },
};
</script>
<style>
</style>
